var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamraicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camraicon",
    transform: "translate(11628 21492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3050",
    "data-name": "Ellipse 3050",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-11628 -21492)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-camera",
    "data-name": "Icon awesome-camera",
    d: "M17.308,6.036v9.736a1.623,1.623,0,0,1-1.623,1.623H1.623A1.623,1.623,0,0,1,0,15.772V6.036A1.623,1.623,0,0,1,1.623,4.414H4.6L5.013,3.3A1.62,1.62,0,0,1,6.531,2.25h4.243A1.62,1.62,0,0,1,12.292,3.3l.419,1.112h2.975A1.623,1.623,0,0,1,17.308,6.036Zm-4.6,4.868a4.057,4.057,0,1,0-4.057,4.057A4.06,4.06,0,0,0,12.711,10.9Zm-1.082,0A2.975,2.975,0,1,1,8.654,7.929,2.979,2.979,0,0,1,11.629,10.9Z",
    transform: "translate(-11616.654 -21481.822)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamraicon);
export default __webpack_public_path__ + "static/media/camraicon.8e6e059964b5b5dfcd7545e5399c8454.svg";
export { ForwardRef as ReactComponent };